import React from 'react';

import Button from '@cube3/ui/src/Buttons/Button';
import Chip from '@cube3/ui/src/chips/Chip';
import { Shimmer } from '@cube3/cubicle/src/core/atoms/Loader/Shimmer';
import { useResource__ALPHA } from '@cube3/state/src/redux/components/Hooks/useResource';
import { statuses } from '@cube3/state/src/redux/ducks/request-status';
import { useModalActions } from '@cube3/main/src/components/app/layout/Modals/modalActions';

const noop = () => null;
const emptyArray = [];
export const AttachmentsField = (props) => {
  const {
    value = emptyArray,
    onChange,
    onFocus = noop,
    metadataForResource = {},
    disabled
  } = props;
  const { openModal } = useModalActions();

  const attachments = useResource__ALPHA<'asset'>({
    resourceIdentifiers: value.map((a) => ({ type: 'asset', id: a }))
  });

  if (value.length && attachments.status !== statuses.SUCCESS) {
    return <Shimmer height={10} weight="light" />;
  }

  return (
    <div>
      <div>
        {attachments.resources?.map((asset) => {
          return (
            <Chip
              key={asset.id}
              input={{ value: asset.display_name, id: asset.id }}
              removeItem={(val, data) => {
                onChange(value.filter((v) => v !== data.id));
              }}
              disabled={false}
              onClick={(data) => {
                openModal(
                  'attachment_preview',
                  {
                    assetId: data.id
                  },
                  false
                );
              }}
            />
          );
        })}
      </div>
      <Button
        colorVariant="ghost1"
        text="Upload files..."
        disabled={disabled}
        onClick={() => {
          onFocus();
          openModal(
            'attachments_field',
            {
              ...props
            },
            false
          );
        }}
      />
    </div>
  );
};
